// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1NnYA","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2IFBY"};